module.exports = __webpack_public_path__ + "static/img/132.bb201fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/132.jpg
// module id = lOKL
// module chunks = 0